import { ThemeEvents } from '@theme/events';
import { Component } from '@theme/component';

/**
 * Keeps a builder flow CTA's `?style=&size=` in step with the variant picker.
 *
 * The picker morphs only itself, so the href is copied out of the section markup the
 * update carries rather than rebuilt here — the params have one definition, in Liquid.
 */
class ProductBuilderCta extends Component {
  /** @type {Element | null} */
  #section = null;

  connectedCallback() {
    super.connectedCallback();
    this.#section = this.closest('.shopify-section, dialog');
    this.#section?.addEventListener(ThemeEvents.variantUpdate, this.#updateLink);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#section?.removeEventListener(ThemeEvents.variantUpdate, this.#updateLink);
  }

  /** @param {Event} event */
  #updateLink = (event) => {
    const link = this.querySelector('a');
    const html = /** @type {any} */ (event).detail?.data?.html;
    const href = html
      ?.querySelector(`product-builder-cta[data-block-id="${this.dataset.blockId}"] a`)
      ?.getAttribute('href');

    if (link instanceof HTMLAnchorElement && href) link.setAttribute('href', href);
  };
}

if (!customElements.get('product-builder-cta')) {
  customElements.define('product-builder-cta', ProductBuilderCta);
}
